// =============================================================================
// dossies.ts — Render compartilhado das pastas de dossiê (#92): 3 missões
// persistentes SEMPRE parcialmente completas, visíveis no menu e no game over.
// Estética de pasta com tarja CONFIDENCIAL; barra de progresso carimbada.
// =============================================================================
import { DOSSIE_TABLE, dossieVotos, type DossieState } from '../../../shared/feitos';
import { dossieIcon } from './pixelIcons';

const fmt = (n: number): string => n.toLocaleString('pt-BR');

// Progresso legível: dossiê de tempo mostra minutos, os demais o número cru
function progresso(d: DossieState): string {
  const def = DOSSIE_TABLE[d.tpl];
  if (def?.formato === 'tempo') {
    return `${Math.floor(d.prog / 60)}/${Math.round(d.alvo / 60)} min`;
  }
  return `${fmt(d.prog)}/${fmt(d.alvo)}`;
}

export function renderDossies(el: HTMLElement, dossies: DossieState[]): void {
  el.innerHTML = '';
  for (const d of dossies) {
    const def = DOSSIE_TABLE[d.tpl];
    if (!def) continue;
    const pct = Math.min(100, (d.prog / d.alvo) * 100);
    const card = document.createElement('div');
    card.className = 'dossie-card';
    card.innerHTML = `
      <span class="dossie-tarja">CONFIDENCIAL</span>
      <div class="dossie-topo">
        ${dossieIcon(20)}
        <span class="dossie-nome">${def.nome(d.alvo)}</span>
      </div>
      <div class="dossie-barra"><div style="width:${pct}%"></div></div>
      <div class="dossie-rodape">
        <span class="dossie-prog">${progresso(d)}</span>
        <span class="dossie-premio">+${fmt(dossieVotos(d.nivel))} votos</span>
      </div>`;
    el.appendChild(card);
  }
}
